import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ListItemButton, ListItemText, Typography } from '@mui/material';


const NavItem = ({ item }) => {

  const location = useLocation();
  //console.log('location',location)
  return (
    <ListItemButton
      sx={{
        borderRadius: '5px',
        marginBottom: '5px',
      }}
      selected={location?.pathname === item?.url || item?.subUrl.includes(location?.pathname)}
      component={Link}
      to={item.url}
    >
      <ListItemText
        primary={
          <Typography sx={{ pl: 1.4 }} variant={'body1'} color="inherit">
            {item.title}
          </Typography>
        }
      />
    </ListItemButton>
  );
};

export default NavItem;
